import { ConnectIntegrationCTA } from '@modules/integrationsV2/components/ConnectIntegrationCTA';
import { Box } from '@mui/material';
import {
  IntegrationChannelViewFragment,
  IntegrationType,
} from 'generated/graphql';

interface DrawerIntegrationCardRightActionsProps {
  integrationChannel: IntegrationChannelViewFragment;
  integrationType: IntegrationType;
  oAuthURL: string | undefined;
  shouldShowAsConnected?: boolean;
}

export const DrawerIntegrationCardRightActions = (
  props: DrawerIntegrationCardRightActionsProps,
) => {
  return (
    <Box>
      <ConnectIntegrationCTA {...props} />
    </Box>
  );
};
